'use client';

import { recordTouchCookies } from '@thebrief-ai/auth-ui';
import { useEffect } from 'react';

/**
 * Writes the first-party `tb_first_touch` / `tb_last_touch` attribution
 * cookies for this page view (DAT-55). Runs once per page load on the client;
 * the first-touch cookie is write-once so repeat renders are harmless.
 */
export default function TouchCookiesBootstrap() {
  useEffect(() => {
    recordTouchCookies();
  }, []);

  return null;
}
